import { Container } from './styles'
import { BrowserRouter as Router } from 'react-router-dom'
import { NavHashLink, HashLink } from 'react-router-hash-link'
import { useState } from 'react'

export function Header() {
  const [isActive, setActive] = useState(false)

  function closeMenu() {
    setActive(false)
  }

  return (
    <Container className="header-fixed">
      <Router>
        <HashLink smooth to="#home" className="logo">
          <span>{"cd ~"}</span>
          <span>{"oybek"}</span>
        </HashLink>

        <nav className={isActive ? 'active' : ''}>
          <NavHashLink smooth to="#home" onClick={closeMenu}>
            ~/home
          </NavHashLink>
          <NavHashLink smooth to="#about" onClick={closeMenu}>
            ~/about
          </NavHashLink>
          <NavHashLink smooth to="#project" onClick={closeMenu}>
            ~/projects
          </NavHashLink>
          <NavHashLink smooth to="#contact" onClick={closeMenu}>
            ~/contact
          </NavHashLink>
          <a href={"https://drive.google.com/file/d/1x9AFCi3ILmsko-5vbxoZ3AJ_xeg60f7V/view?usp=sharing"} target='_blank' rel="noopener noreferrer" className="button">
            CV.pdf
          </a>
        </nav>

        <div
          aria-expanded={isActive ? 'true' : 'false'}
          aria-haspopup="true"
          aria-label={isActive ? 'Close menu' : 'Open menu'}
          className={isActive ? 'menu active' : 'menu'}
          onClick={() => {
            setActive(!isActive)
          }}
        ></div>
      </Router>
    </Container>
  )
}
